import { VIEWS } from './UpsertAccountModalConstants';
import * as actions from './UpsertAccountModalActions';
import * as netWorthSidebarActions from '../ContextualSidebar/NetWorthSidebar/NetWorthSidebarActions';

const initialState = {
  isModalVisible: false,
  currentView: VIEWS.LIST,
  focusedAccount: null,
  defaultPrincipalOwner: null,
  accountTypes: [],
  visibleAccountTypesStack: [],
  errors: [],
  isSavingAccount: false,
  isDeletingAccount: false,
  accountTypesDictionary: {},
  otherAssetTypesDictionary: {},
  isFocusedAccountNew: true,
  isFocusedAccountEditable: true,
  isConfirmationModalOpen: false,
  redirectUrl: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actions.ERRORS_SET:
      return { ...state, errors: payload };
    case actions.IS_CONFIRMATION_MODAL_OPEN:
      return { ...state, isConfirmationModalOpen: payload };
    case actions.CURRENT_VIEW_SET: {
      const visibleAccountTypesStack =
        payload === VIEWS.LIST ? [state.accountTypes] : state.visibleAccountTypesStack;

      return {
        ...state,
        visibleAccountTypesStack,
        currentView: payload,
        errors: [],
      };
    }
    case actions.FOCUSED_ACCOUNT_SET:
      return {
        ...state,
        focusedAccount: payload.focusedAccount,
        isFocusedAccountNew: payload.isNew,
        isFocusedAccountEditable: payload.isEditable,
      };
    case netWorthSidebarActions.NETWORTH_DATA_SET: {
      const convertAccountTypesDictionaryToArray = accountTypes =>
        Object.keys(accountTypes).map((accountTypeName) => {
          const { AccountType: accountType, OtherAssetType: otherAssetType } = accountTypes[
            accountTypeName
          ];

          if (accountType !== undefined) {
            return { name: accountTypeName, isAsset: false, type: accountType };
          }

          if (otherAssetType !== undefined) {
            return { name: accountTypeName, isAsset: true, type: otherAssetType };
          }

          return {
            name: accountTypeName,
            subTypes: convertAccountTypesDictionaryToArray(accountTypes[accountTypeName]),
          };
        });

      const accountTypes = convertAccountTypesDictionaryToArray(payload.Options.AddAccountTypes);

      return {
        ...state,
        accountTypes,
        visibleAccountTypesStack: [accountTypes],
        defaultPrincipalOwner: payload.Options.DefaultPrincipalOwner,
        accountTypesDictionary: payload.Options.EditableAccountTypes,
        otherAssetTypesDictionary: payload.Options.EditableOtherAssetTypes,
      };
    }
    case actions.VISIBLE_ACCOUNT_TYPES_PUSH:
      return {
        ...state,
        visibleAccountTypesStack: [...state.visibleAccountTypesStack, payload],
      };
    case actions.VISIBLE_ACCOUNT_TYPES_POP:
      return {
        ...state,
        visibleAccountTypesStack:
          state.visibleAccountTypesStack.length > 1
            ? state.visibleAccountTypesStack.slice(0, -1)
            : state.visibleAccountTypesStack,
      };
    case actions.IS_SAVING_ACCOUNT_SET:
      return { ...state, isSavingAccount: payload };
    case actions.IS_DELETING_ACCOUNT_SET:
      return { ...state, isDeletingAccount: payload };
    case actions.SET_REDIRECT_URL:
      return {
        ...state,
        redirectUrl: payload,
      };
    case actions.CLEAR_REDIRECT_URL:
      return {
        ...state,
        redirectUrl: initialState.redirectUrl,
      };
    default:
      return state;
  }
};
